import { render } from "./ServiceJobComponentGroupView.vue?vue&type=template&id=82aafafa&scoped=true&ts=true"
import script from "./ServiceJobComponentGroupView.vue?vue&type=script&lang=ts"
export * from "./ServiceJobComponentGroupView.vue?vue&type=script&lang=ts"

import "./ServiceJobComponentGroupView.vue?vue&type=style&index=0&id=82aafafa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82aafafa"]])

export default __exports__